
// https://advancedweb.hu/how-to-add-timeout-to-a-promise-in-javascript/

import { DicomMetadataStore, classes } from '@ohif/core';

import JSZip from 'jszip';
import FileLoaderService from '../../../platform/viewer/src/routes/Local/fileLoaderService';

//console.log('extensions/default/src/init.js');

const retries_number = 2;
var retries = retries_number;

/**
 *
 * @param {Object} servicesManager
 * @param {Object} configuration
 */
export default function init({ servicesManager, configuration }) {
}

async function downloadFile(file) {
  console.log('starting to download:', file)
  return new Promise((resolve, reject) => {

    // console.log('actual file:', file)
    const xhr = new XMLHttpRequest();

    xhr.addEventListener('error', error => {
      console.log('An error occurred while retrieving the JSON data');
      reject(error);
    });

    xhr.addEventListener('timeout', error => {
      console.log('Timeout error');
      reject(error);
    });

    xhr.addEventListener('progress', event => {
      // console.log('file, xhr progress, computable', file, event.loaded, event.lengthComputable);
      if (event.lengthComputable) {
        DicomMetadataStore.setDownloadedFileSize(file, event.loaded);
        // console.log('file, percent:', file, (event.loaded / event.total * 100) | 0);  // '| 0' = int
      }

    });

    xhr.addEventListener('load', event => {
      if (event.target.status === 404) {
        reject(new Error('file not found'));
      } else {
        if (!xhr.response) {
          console.log('Response was undefined');
          reject(new Error('Response was undefined'));
        } else {
          const blob = xhr.response;
          resolve(blob);
        }
      }
    });

    xhr.open('GET', '/api/getfile?f=' + file); // Setting the timeout after open because of IE11 issue: https://gitlab.com/meno/dropzone/issues/8
    // xhr.timeout = 60000; // Has to be after `.open()`

    xhr.responseType = "blob";
    xhr.send();

  });
}



async function addImage(file) {
  try {
    const fileLoaderService = new FileLoaderService(file);
    const imageId = fileLoaderService.addFile(file);
    const image = await fileLoaderService.loadFile(file, imageId);
    const dicomJSONDataset = await fileLoaderService.getDataset(image, imageId);

    if ((dicomJSONDataset.SOPClassUID === '1.2.840.10008.5.1.4.1.1.4')
    ) {
      DicomMetadataStore.addInstance(dicomJSONDataset);
    }
    // else {
    //   console.log('not MR!', dicomJSONDataset.SOPClassUID);
    // }
  } catch (error) {
    console.log(
      error.name,
      ':Error when trying to load and process downloaded files:',
      error.message
    );
  }
}

async function getFile(file) {
  return new Promise((resolve, reject) => {
    downloadFile(file).then(
      async function (output) {
        const zip = new JSZip();
        const unzipped = await zip.loadAsync(output);

        const filenames = Object.keys(unzipped.files);

        for (const filename of filenames) {
          const blob = await zip.file(filename).async('blob');
          await addImage(blob);
        }
        resolve(1);
      },
      function (error) {
        console.log('reject in getFiles, ', error);
        reject(error);
      });
  })
}

async function longPoll() {
  console.log('longpoll');
  return new Promise((resolve, reject) => {

    const xhr = new XMLHttpRequest();

    xhr.addEventListener('error', error => {
      console.log('An error occurred while retrieving the JSON data', error);
      reject(error);
    });

    xhr.addEventListener('timeout', error => {
      console.log('Timeout error');
      reject(error);
    });

    xhr.addEventListener('load', event => {
      if (event.target.status === 404) {
        reject(new Error('No JSON data found'));
      } else {
        if (!xhr.responseText) {
          console.log('Response was undefined');
          reject(new Error('Response was undefined'));
        } else {
          try {
            const data = JSON.parse(xhr.responseText);
            resolve(data);
          } catch (e) {
            reject(new Error('JSON parse error'));
          }
        }
      }
    });

    xhr.open('GET', '/api/longpoll'); // Setting the timeout after open because of IE11 issue: https://gitlab.com/meno/dropzone/issues/8
    xhr.timeout = 100000; // Has to be after `.open()`

    xhr.setRequestHeader('Accept', 'application/json');
    xhr.send();
  });
}

// https://stackoverflow.com/questions/43780163/javascript-while-loop-where-condition-is-a-promise
function poll() {

  console.log('poll');
  const studyUIDs = DicomMetadataStore.getStudyInstanceUIDs();

  return longPoll().then(async function (output) {
    retries = retries_number;
    console.log('long poll progress: ', output.progress);
    DicomMetadataStore.updateProgressText(studyUIDs[0], output.status);
    DicomMetadataStore.setProgressValue(studyUIDs[0], output.progress);

    if (output.error) {
      console.log('backend error!:', output.error);
      DicomMetadataStore.updateInferenced(studyUIDs[0], false, output.error);
      DicomMetadataStore.updateInferenceInProgress(studyUIDs[0], false);
      DicomMetadataStore.updateProgressText(studyUIDs[0], undefined);
    }
    else {
      if (output.files) {

        // console.log('getfiles', output.files);
        DicomMetadataStore.setProgressValue(studyUIDs[0], 0);
        DicomMetadataStore.updateProgressText(studyUIDs[0], 'downloading:');
        DicomMetadataStore.setFileSizeToDownload(output.size);

        const parallelDownload = true; //false;

        // https://stackoverflow.com/questions/37576685/using-async-await-with-a-foreach-loop
        if (!parallelDownload) {
          for (const file of output.files) {
            await getFile(file);
          }
        } else {
          const processFilesPromises = output.files.map(getFile);
          await Promise.all(processFilesPromises);
        }

        DicomMetadataStore.updateInferenced(studyUIDs[0], true, undefined);
        DicomMetadataStore.updateInferenceInProgress(studyUIDs[0], false);
        DicomMetadataStore.updateProgressText(studyUIDs[0], undefined);
        DicomMetadataStore.triggerInstancesAdded(false);

      } else {
        return poll();
      }
    }
  }).catch((err) => {
    console.log('longpoll error, retries:', err, retries);
    if (retries) {
      setTimeout(() => {
        console.log('poll again');
        retries--;
        return poll();
      }, 1000);
    }
    else {
      console.log('no more retries');
      DicomMetadataStore.setProgressValue(studyUIDs[0], 0);
      DicomMetadataStore.updateInferenced(studyUIDs[0], false, 'Timeout waiting for server response');
      DicomMetadataStore.updateInferenceInProgress(studyUIDs[0], false);
      DicomMetadataStore.updateProgressText(studyUIDs[0], undefined);
    }
  });
}

const InferenceStarted = ({ StudyInstanceUID, InferenceInProgress }) => {
  console.log('inference started', StudyInstanceUID, InferenceInProgress);

  retries = retries_number;

  // https://stackoverflow.com/questions/43780163/javascript-while-loop-where-condition-is-a-promise
  poll().then(function () {
  }).catch(function (err) {
    console.log('reject in longPoll, ', err);
  });
};

//console.log('subscribe inference started');
DicomMetadataStore.subscribe(
  DicomMetadataStore.EVENTS.INFERENCE_STARTED,
  InferenceStarted
);
